import styled from 'styled-components'
import Image from "next/legacy/image";
import Link from 'next/link'
import { SectionHeading, Detail } from 'src/styles/Typography'
import VerticalIcon from 'src/components/icons/vertical'
import { ContainerSmall } from 'src/styles/Container'

const year = new Date().getFullYear()

function VerticalProviders({ vertical, providers }) {
  if (!vertical?.slug) {
    return null
  }

  const verticalSlug = vertical.slug.replace('-insurance', '')
  const urlBase = `/${vertical.slug}/reviews`

  return (
    <Wrapper verticalSlug={verticalSlug}>
      <ContainerSmall>
        <div>
          <Top>
            <SectionHeadingWithColor verticalSlug={verticalSlug}>
              <VerticalIconStyle>
                <VerticalIcon icon={verticalSlug} />
              </VerticalIconStyle>{' '}
              {vertical?.title}
            </SectionHeadingWithColor>
            <Detail>/</Detail>
            <SectionHeading color="sectionHeading">{year} Best Providers</SectionHeading>
          </Top>
          <Providers>
            {providers.map((provider, index) => (
              <div key={index}>
                <Link href={`${urlBase}/${provider.slug}`} passHref legacyBehavior>
                  <Provider>
                    <Image
                      src={provider.logo.url}
                      quality={40}
                      width="48"
                      height="48"
                      alt={provider.logo.description || ''}
                      objectFit="contain"
                    />
                    <div>
                      <div>{provider.title}</div>
                      {/* <div>{provider.shortParagraph}</div> */}
                    </div>
                  </Provider>
                </Link>
              </div>
            ))}
          </Providers>
        </div>
      </ContainerSmall>
    </Wrapper>
  );
}

export default VerticalProviders

const Providers = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 24px;
  margin-top: 2.5rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    grid-template-columns: 1fr;
  }
`

const Provider = styled.a`
  display: flex;
  align-items: center;
  gap: 24px;
  color: ${({ theme }) => theme.colors.base};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`

const Wrapper = styled.div`
  background: ${({ theme, verticalSlug }) => theme.colors[verticalSlug].shadeDark};
  padding: 3.5rem 0 4rem;
`

const Top = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 14px;
`

const VerticalIconStyle = styled.span`
  display: inline-block;
  vertical-align: middle;
  margin-right: 1rem;
  svg {
    max-width: 21px;
  }
`

const SectionHeadingWithColor = styled(SectionHeading)`
  padding-right: 2px;
  margin: 0x;
  color: ${({ verticalSlug, theme }) =>
    verticalSlug ? theme.colors[verticalSlug].DEFAULT : theme.colors.brand.DEFAULT};
`
